<template lang="pug">

  transition(
    @enter="enter"
    @leave="leave" 
    appear
    )
    a(
      v-if="show" 
      @focus="onMouseEnter" 
      @mouseenter="onMouseEnter" 
      @blur="onMouseLeave" 
      @mouseleave="onMouseLeave" 
      :class="{ 'white' : isWhite, 'menu-open' : isMenuOpen }" 
      :href="lang_en['site-check-rating-url']" 
      :aria-label="lang_en['site-check-rating-btn']" 
      :target="'_blank'" 
    )#right-car-logo
      .bg(ref="bg")
      logo-svg

</template>

<script>

import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES, PATHS, EVENTS } from 'src/config/app'
import Env from 'src/config/env'
import LogoSvg from '@/assets/svgs/RightCar_logo.svg'
import gsap from 'gsap'
import Communicator from '@/helpers/Communicator'

export default {

  components: {
    LogoSvg
  },

  data() {
    return {
      isWhite: true
    }
  },

  computed: {

    ...mapState('app', ['modal_state', 'home', 'motion_clamp']),

    isMenuOpen(){
      return (this.modal_state === MODAL_STATES.MENU)
    },

    show(){
      return (Env.desktop || Env.tablet) || ( Env.mobile && ( this.home.section_index === 0 || this.modal_state === MODAL_STATES.MENU ) )
    }
  },

  methods: {
    //...mapMutations('app',[ 'setModalState']),

    enter(el, done){
      gsap.to( el, 1 * this.motion_clamp, { opacity : 1, delay: 1 * this.motion_clamp})
      gsap.delayedCall(0 , this.updateColor)
      done()
    },

    leave(el, done){
      gsap.to(this.$el, 0.5 * this.motion_clamp, { opacity : 0, onComplete: done }) 
    },

    updateColor(el = this.$el){
      switch(this.modal_state) {
        case MODAL_STATES.MENU:
          this.isWhite = false
          break;
        case MODAL_STATES.NONE:
          this.isWhite = true
          break;
      }
    },

    onMouseEnter( ){ 
      Communicator.trigger(EVENTS.MOUSE_ENTER)
    },

    onMouseLeave( ){
      Communicator.trigger(EVENTS.MOUSE_LEAVE)
    }
  },

  watch: {
    modal_state(val){
      this.updateColor()
    }
  }
}

</script>

<style lang="sass">
@import "src/styles/common.sass"

#right-car-logo
  top: 6rem
  height: 44px
  position: absolute
  left: $bp-desktop-margin
  display: flex
  align-items: center
  justify-content: center
  pointer-events: auto
  opacity: 0
  outline: none
  margin-top: -13px

  .ie11 &
    display: block
    width: 110px

    
    &:hover
      .bg
        opacity: 0
      svg
        transform: scale(1)
        .car_bg,
        .car_font,
        .car_left,
        .car_right
          fill: #FFFFFF !important

 
  .bg
    transform: scale(1) 
    transition: transform 0.1s ease-in-out, opacity 0.3s ease-in-out
    background: white
    border-radius: 50%
    opacity: 0
    position: absolute
    top: 0
    height: 100%
    width: 100%
    border-radius: 22px
    height: 44px
    min-width: 150px
    transform: scale(0.9)


  &.menu-open
    .bg
      background: #282C68

 

  &:hover,
  &:focus

    .bg
      transition: transform 0.2ss ease-out, opacity 0.1s ease-out
      opacity: 0.92
      transform: scale(1)

    svg 
      transition : transform 0.1s ease-out 
      transform: scale(0.8) 
      height: 20px
      position: relative

      .car_bg
        fill: #CFEC35 !important

      .car_font
        fill: #044DC2 !important

      .car_left,
      .car_right
        fill: #478E24 !important

    &.menu-open 
      svg
        .car_bg,
        .car_font,
        .car_left,
        .car_right
          fill: #FFFFFF !important



  @media all and (max-width: $bp-tablet)
    left: $bp-tablet-margin

  @media all and (max-width: $bp-mobile)
    left: auto
    position: relative
    top: auto
    width: 120px
    margin: 0 auto

  &.white
    svg
      .car_bg,
      .car_font,
      .car_left,
      .car_right
        fill: #FFFFFF

  svg
    transition : transform 0.3s ease-out 
    height: 20px
    position: relative

    .car_bg,
    .car_font,
    .car_left,
      .car_right
        transition : fill 1s ease-in-out

    .car_bg
      fill: #CFEC35

    .car_font
      fill: #044DC2

    .car_left,
    .car_right
      fill: #478E24


</style>
